export default __webpack_public_path__ + "static/media/seeder_refill.fb01c996.svg";